import styled from "styled-components";

// @ts-expect-error: This is how we utilize dynamic imports with WebPack NormalModuleReplacementPlugin (webpack.config.js)
import EditButton from "./EditButton-APP_CLIENT.styled";

interface TitleProps {
  direction: "ltr" | "rtl";
}

const Title = styled.div<TitleProps>`
  display: flex;
  align-items: center;

  ${EditButton} {
    margin-bottom: 8px;
    margin-left: ${({ direction }) =>
      direction === "ltr" ? "16px" : "initial"};
    margin-right: ${({ direction }) =>
      direction === "rtl" ? "16px" : "initial"};
  }
`;

export default Title;
